import CreateInviteModal from "./CreateInviteModal";

export default CreateInviteModal;
